import { createContext, useContext, type ReactNode } from "react";
import type { useDataStructureRouting } from "./useDataStructureRouting";

type DataStructureRoutingContextValue = ReturnType<typeof useDataStructureRouting>;

const DataStructureRoutingContext = createContext<DataStructureRoutingContextValue | null>(
  null,
);

type DataStructureRoutingProviderProps = {
  value: DataStructureRoutingContextValue;
  children: ReactNode;
};

export const DataStructureRoutingProvider = ({
  value,
  children,
}: DataStructureRoutingProviderProps) => (
  <DataStructureRoutingContext.Provider value={value}>
    {children}
  </DataStructureRoutingContext.Provider>
);

export const useDataStructureRoutingContext = (): DataStructureRoutingContextValue => {
  const ctx = useContext(DataStructureRoutingContext);
  if (!ctx) {
    throw new Error(
      "useDataStructureRoutingContext must be used within a DataStructureRoutingProvider",
    );
  }
  return ctx;
};
